<template>
  <div class="services">
    <div class="container mx-auto flex gap-4 flex-col lg:py-16 py-10 px-3 ">
      <div class="text-primary font-primary font-semibold text-lg">
        Our Services
      </div>
      <div class="flex flex-col md:flex-row  md:justify-between md:items-center items-start font-bold gap-5">
        <h3 class="lg:text-4xl text-2xl font-primary">Expert Plumbing Solutions for Your Needs
</h3>
        <div v-if="$route.name !== 'services'">
          <router-link :to="{ name: 'services' }"
            class="px-8 py-3 bg-primary text-white my-3 md:my-0 hover:bg-darkblue hover:text-white">All Services
          </router-link>
        </div>
      </div>
      <div class="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5 mt-3">
        <div v-for="item, index in services" :key="index">
          <ServiceCard :items="item" />
        </div>
        <!-- more service card -->
        <div class="background">
          <div
          class="w-full h-full hover:shadow-xl shadow-md duration-500  border-grey-400 overflow-hidden rounded-sm background  group cursor-pointer">
          <img src="../../assets/v-1.1/ServicesdetailImages/More-service-image.webp" class="lg:max-h-[300px] max-h-[250px] duration-500 w-full group-hover:scale-110" alt="image"
            width="" height="" />
          <div class="p-4 background">
            <div class="font-sans">
              <a href="tel:6478958107"><h2 class="py-3 text-2xl font-primary font-semibold group-hover:cursor-pointer group-hover:text-primary"
               >Custom Plumbing and Heating Services</h2></a>
              <p class="text-base text-grey ">Need a custom solution? Our experts craft & deliver plumbing and heating services tailored to your needs.</p>
            </div>
            <button class=" relative overflow-hidden btn w-full flex flex-row justify-center items-center bg-primary rounded-sm my-4">
              <div
                class=" col-span-2 bg-primary duration-500 flex justify-center items-center p-3 rounded-sm w-[65px] h-[65px]">
                <a href="tel:6478958107">   <img src="../../assets/v-1.1/Icons/contact.svg" class="object-fill text-white" alt="svg" width="" height="" /></a>
              </div>
              <div
                class="flex justify-end col-span-10 px-2 items-center  relative bottom-0"
               >
                <a href="tel:6478958107"><span class="font-semibold text-white font-primary" href="tel:6478958107">Contact us ?</span></a>
                <!-- <div class="bg-primary text-white rounded-full overflow-hidden ml-5 p-2">
                  <a href="tel:6478958107"><img src="../../assets/v-1.1/right-arrow.svg" class="text-white" width="20" height="20" alt="img" /></a>
                </div> -->
              </div>
            </button>
          </div>
        </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import ServiceCard from "../cards/serviceCard.vue";
import { SERVICES } from "../../constants/constants";

const services = SERVICES;

</script>
<style scoped>
.services {
  background-image: url("../../assets/v-1.1/service-banner.webp");
  background-color: #FFFCFA;
  background-position: left bottom;
  background-size: fill;
  background-repeat: no-repeat;
}
button.btn::after {
  content: '';
  position: absolute;
  width: 100px;
  height: 100%;
  top: 0;
  left: -100px;
  background-image: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.7), transparent);
  animation: shine 4s linear infinite;

}

button.btn:hover {
  opacity: 0.8;
  transition-duration: 0.3s;
}

@keyframes shine {
  0% {
    left: -100px;
  }

  20% {
    left: 100%;
  }

  100% {
    left: 100%;
  }
}
.background{
  background: #FEF5E3;
}
</style>